<template>
  <div :class="`col-md-${columnWidth} full-tab-border-right`">
    <h6 class="tab-column-heading">{{ name }}</h6>

    <div class="mt-4">
      <div class="priority-details">
        <div class="priority-details-section mb-5">
          <h6>Rating</h6>
          <div class="priority-rating deficient" v-if="rating === `deficient`">
            <span class="priority-rating-text">Risk</span>
          </div>
          <div class="priority-rating good" v-if="rating === `good`">
            <span class="priority-rating-text">Good</span>
          </div>
          <div class="priority-rating better" v-if="rating === `better`">
            <span class="priority-rating-text">Better</span>
          </div>
          <div class="priority-rating best" v-if="rating === `best`">
            <span class="priority-rating-text">Best</span>
          </div>
        </div>
        <div class="priority-details-section mb-5">
          <h6>Priority for improvement</h6>
          <div class="priority-improvement">
            <span class="priority-improvement-level" v-if="rating === 'deficient'">Highest Priority</span>
            <span class="priority-improvement-level" v-if="rating === 'good'">High Priority</span>
            <span class="priority-improvement-level" v-if="rating === 'better'">Medium Priority</span>
            <span class="priority-improvement-level" v-if="rating === 'best'">No Actions Needed</span>

            <p class="priority-improvement-text mt-4" v-if="rating === 'deficient'">
              Your dealership has no practices in place for improving Technician retention in this category.
            </p>
            <p class="priority-improvement-text mt-4" v-if="rating === 'good'">
              Your dealership has some starter practices in place for improving Technician retention in this category.
            </p>
            <p class="priority-improvement-text mt-4" v-if="rating === 'better'">
              Your dealership has advanced practices in place for improving Technician retention in this category.
            </p>
            <p class="priority-improvement-text mt-4" v-if="rating === 'best'">
              Congratulations. Your dealership has best practices in place for improving Technician retention in this category.
            </p>
          </div>
        </div>
        <div class="priority-details-section mb-5">
          <div class="priority-practices" v-if="rating !== `best`">
            <h6>Practices you should implement</h6>
            <b-form-group>
              <b-form-checkbox-group
                  name="compensation-priorities"
                  stacked
                  plain
              >
                <slot></slot>
<!--                <b-form-checkbox value="cp1"><span>Take a pulse of technician pay satisfaction</span></b-form-checkbox>-->
<!--                <b-form-checkbox value="cp2"><span>Conduct a Business Case to assess trade-off costs of raises</span></b-form-checkbox>-->
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportColumn",
  props: {
    rating: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    columnWidth: {
      type: String,
      required: true
    }
  },
  data(){
    return {
    }
  },
  created() {
  },
  methods: {
    uncheckAll() {
      this.checkedItems = ["uncheckAll"]
    },
    changeCheck() {
      this.checkedItems = this.checkedItems.filter(e => e !== 'uncheckAll')
    }
  },
  watch: {
    checkedItems() {
      this.$emit("selected", this.checkedItems)
    }
  }
}
</script>

<style lang="scss" scoped>

$ratingColorRisk: #a6020d;
$ratingColorGood: #feb53a;
$ratingColorBetter: #006624;
$ratingColorBest: #102b4e;

// TODO: Find a sane place to put this, it used to only work in Chrome.
.selected-priority {
  background-color: $fordBlue;
  font-family: FordAntennaCond-Regular, sans-serif;
  color: #fff;
  width: 100.5%;
  height: 20px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: -0.25%;
  cursor: default;
  border-radius: 8px 8px 0 0;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: .75px;
}

#report {
  padding: 25px 30px;
  .select-priority {
    p {
      letter-spacing: .88px;
    }
    .select-priority-heading {
      font-family: FordAntennaCond-Regular, sans-serif;
      text-transform: uppercase;
      color: $fordBlue;
    }
    .download-assessment {
      font-family: FordAntennaCond-Regular, sans-serif;
      color: $fordBlue;
      text-decoration: underline;
      svg {
        padding-right: 5px;
        path {
          fill: $fordBlue;
        }
      }
    }
    /deep/ .dealership-priority {
      @extend .custom-dropdown;
      width: 265px;
      .vs__dropdown-toggle {
        background: #fff;
      }
      .vs__dropdown-menu {
        .vs__dropdown-option {
          padding: 8px 20px;
        }
      }
    }
  }

  /deep/ .tabs {
    .tab-column-heading {
      min-height: 60px;
      @extend .tab-heading;
      font-size: 25px;
      font-family: FordAntennaCond-Light, sans-serif;
    }
    .nav-tabs {
      /*z-index: 2;*/
      /*position: relative;*/
      .nav-link {
        .selected-priority {
          background-color: $fordBlue;
          font-family: FordAntennaCond-Regular, sans-serif;
          color: #fff;
          width: 100.5%;
          height: 20px;
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          top: 0;
          left: -0.25%;
          cursor: default;
          border-radius: 8px 8px 0 0;
          text-transform: uppercase;
          font-size: 12px;
          letter-spacing: .75px;
        }
      }
    }
  }
  .priority-details {
    .priority-details-section {
      h6 {
        font-family: FordAntennaCond-Regular, sans-serif;
        letter-spacing: 0;
        color: #4a6579;
      }
      .priority-rating {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 8px 30px;
        height: 42px;
        background-color: $fordBlue;
        color: #fff;
        &.deficient {
          background-color: $ratingColorRisk;
          span:before {
            content: "\f00d";
            font-weight: 300;
            font-family: 'Font Awesome 5 Pro', sans-serif;
            padding-right: 10px;
          }
        }
        &.good {
          background-color: $ratingColorGood;
        }
        &.better {
          background-color: $ratingColorBetter;

          span:before {
            content: "\f00c";
            font-weight: 300;
            font-family: 'Font Awesome 5 Pro', sans-serif;
            padding-right: 10px;
          }
        }
        &.best {
          background-color: $ratingColorBest;
          span:before {
            content: "\f2f7";
            font-weight: 300;
            font-family: 'Font Awesome 5 Pro', sans-serif;
            padding-right: 10px;
          }
        }
        .priority-rating-text {
          text-transform: uppercase;
          color: #fff;
          font-family: FordAntennaCond-Regular, sans-serif;
          font-size: 22px;
          font-weight: 500;
          letter-spacing: 0;
        }
      }
      .priority-improvement {
        .priority-improvement-level {
          font-family: FordAntennaCond-Regular, sans-serif;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: $fordBlue;
          font-size: 1rem;
        }
        .priority-improvement-text {
          font-family: FordAntennaCond-Regular, sans-serif;
          letter-spacing: .88px;
          margin-bottom: 0;
        }
      }
      .priority-practices {
        /deep/ .form-group {
          padding-left: 5px;
          /deep/.form-check {
            &:not(:last-of-type) {
              margin-bottom: 10px;
            }
            .form-check-label {
              span {
                font-family: FordAntennaCond-Regular, sans-serif;
              }
            }
            input[type="checkbox"] {
              appearance:none;
              width: 15px;
              height: 15px;
              border: 1px solid #8b8c8c;
              border-radius: 2px;
              &:checked {
                background: #fff;
                border-color: $fordBlue;
                &:before {
                  content: "\f14a";
                  position: absolute;
                  top: -6px;
                  font-size: 15px;
                  font-weight: 900;
                  left: 0;
                  font-family: 'Font Awesome 5 Free', sans-serif;
                  color: $fordBlue;
                }
              }

            }
          }
        }
      }
    }
  }
  .accordion {
    .card-header {
      .selected-priority {
        background-color: #102b4e;
        font-family: FordAntennaCond-Regular, sans-serif;
        color: #fff;
        width: 100.5%;
        height: 18px;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: -0.25%;
        cursor: default;
        /*border-radius: 8px 8px 0 0;*/
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: .75px;
      }
      span {
        &:not(.selected-priority) {
          height: 100%;
          letter-spacing: .88px;
        }
      }
    }
  }
}

// Hide disabled checkboxes on this page only
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  visibility: hidden;
}
</style>
